import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  Stack,
  IconButton,
  Grid,
  MenuItem,
} from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";
import { motion } from "framer-motion";
import configServ from "../../services/config";
import { toast } from "react-hot-toast";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import CancelIcon from "@mui/icons-material/Cancel";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import { useSelector } from "react-redux";

// List of Indian states
const states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

// Departments list
const departments = ["HR", "Finance", "Marketing", "IT", "Operations"];

// Type list
const types = ["Fixed", "Vary"];

const CostMasterCard = ({
  isEdit,
  setIsEdit,
  editData,
  isCreate,
  setIsCreate,
  fetchCostMaster,
  permissionsList,
}) => {
  //#region
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const { user_id, company_id } = useSelector((state) => state.GlobalVariables);
  const [locationList, setLocationList] = useState([]);

  const initialFormData = {
    name: "",
    code: "",
    description: "",
    department: "",
    owner: "",
    create_date: "",
    location: "",
    validity: "",
    type: "",
    status: false,
    company_id: company_id,
    created_by: user_id,
  };

  const [formData, setFormData] = useState(initialFormData);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const createCostMaster = async () => {
    const dataToSend = {
      ...formData, // Menu-level fields
      // Submenu-level fields
    };
    console.log("dataToSend=", dataToSend);
    try {
      setOpenBackdrop(true);
      const res = await configServ.createCostMaster(dataToSend);
      if (res.status === 200) {
        toast.success("costMaster created successfully!");
        handleReset(); // Reset the form after successful creation
        fetchCostMaster();
      } else {
        toast.error("costMaster creation failed!");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
    } finally {
      setOpenBackdrop(false);
    }
  };

  useEffect(() => {
    setOpenBackdrop(true);
    if (isEdit && editData) {
      setFormData({
        id: editData.id || "", // Since you replaced `id` with `sNo`
        code: editData.code || "",
        name: editData.name || "",
        description: editData.description || "",
        department: editData.department || "",
        owner: editData.owner || "",
        type: editData.type || "",
        location: editData.location || "",
        create_date: editData.create_date || "",
        validity: editData.validity || "",
        status: editData.status || false,
        created_by: editData.created_by || "",
        updated_by: user_id,
        company_id: company_id,
      });
    }
    setOpenBackdrop(false);
  }, [isEdit, editData]);

  const updateCostMaster = async () => {
    const dataToSend = {
      ...formData,
    };
    console.log("dataToSend=", dataToSend);
    try {
      setOpenBackdrop(true);
      const res = await configServ.updateCostMaster(dataToSend);
      if (res.status === 200) {
        toast.success("costMaster update successfully!");
        handleReset(); // Reset the form after successful creation
        fetchCostMaster();
      } else {
        toast.error("costMaster update failed!");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
    } finally {
      setOpenBackdrop(false);
    }
  };

  const handleReset = () => {
    setFormData(initialFormData);
  };

  const handleCut = () => {
    handleReset();
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const fetchLocation = async () => {
    try {
      const res = await configServ.getLocation({
        company_id: company_id,
      });

      setLocationList(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  //#endregion
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95, y: -20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: -20 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      style={{
        width: "100%",
        backgroundColor: "#e3f3fc",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <LoaderBackdrop open={openBackdrop} />

      {/* Input Fields */}
      <Grid container spacing={2} sx={{ width: "100%", marginBottom: 2 }}>
        <Grid item xs={12} sm={4}>
          <TextField
            name="name"
            label="Name"
            variant="outlined"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            name="code"
            label="Code"
            variant="outlined"
            value={formData.code}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            name="description"
            label="Description"
            variant="outlined"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            size="small"
            multiline
            rows={3}
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            name="department"
            label="Department"
            variant="outlined"
            value={formData.department}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          >
            {departments.map((dept) => (
              <MenuItem key={dept} value={dept}>
                {dept}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            name="owner"
            label="Owner"
            variant="outlined"
            value={formData.owner}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            type="date"
            name="create_date"
            label="Create Date"
            variant="outlined"
            value={formData.create_date}
            onChange={handleChange}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            name="location"
            label="Location"
            variant="outlined"
            value={formData.location}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          >
            {locationList.map((state) => (
              <MenuItem key={state.id} value={state.location_name}>
                {state.location_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            type="date"
            name="validity"
            label="Validity"
            variant="outlined"
            value={formData.validity}
            onChange={handleChange}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            name="type"
            label="Type"
            variant="outlined"
            value={formData.type}
            onChange={handleChange}
            fullWidth
            size="small"
            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          >
            {types.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControlLabel
            control={
              <Checkbox
                name="status"
                checked={formData.status}
                onChange={handleCheckboxChange}
              />
            }
            label="Active"
            sx={{ color: "#555" }}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: "100%",
          justifyContent: "flex-end",
          marginTop: 2,
        }}
      >
        {isEdit ? (
          <IconButton
            onClick={handleCut}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
              boxShadow: 2,
              ml: 1,
              transition: "all 0.3s ease",
            }}
            title="cut"
          >
            <CancelIcon sx={{ fontSize: 18 }} />
          </IconButton>
        ) : (
          <IconButton
            onClick={handleReset}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
              backgroundColor: "secondary.main",
              color: "white",
              "&:hover": {
                backgroundColor: "secondary.dark",
              },
              ml: 1,
            }}
            title="Reset"
          >
            <RotateLeftIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
        <IconButton
          size="small"
          onClick={isEdit ? updateCostMaster : createCostMaster}
          sx={{
            borderRadius: 2,
            px: 2,
            py: 1,
            backgroundColor: isEdit ? "success.main" : "primary.main",
            color: "white",
            "&:hover": {
              backgroundColor: isEdit ? "success.dark" : "primary.dark",
            },
          }}
          title={isEdit ? "Update" : "Save"}
        >
          <SaveIcon sx={{ fontSize: 22 }} />
        </IconButton>
      </Stack>
    </motion.div>
  );
};

export default CostMasterCard;
